import './breadcrumbs.scss';
import React, { Fragment, memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon, useTheme } from '..';
const Breadcrumbs = _ref => {
  let {
    breadcrumbs,
    onBreadcrumbClick
  } = _ref;
  const {
    theme
  } = useTheme();
  return !!breadcrumbs.length && /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-breadcrumbs', theme)
  }, breadcrumbs.map((item, index) => /*#__PURE__*/React.createElement(Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "wrts-breadcrumb-btn",
    onClick: () => onBreadcrumbClick(item.link)
  }, item.name), /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-right"
  }))));
};
Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.object),
  onBreadcrumbClick: PropTypes.func
};
Breadcrumbs.defaultProps = {
  breadcrumbs: [],
  onBreadcrumbClick: () => {}
};
export default /*#__PURE__*/memo(Breadcrumbs);